import { createStyles } from '@material-ui/core';

export const styles = () =>
  createStyles({
    timestamp: {
      marginTop: '-16px',
    },
  });
